import * as React from "react";

const IconMinus: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" viewBox="0 0 10 2" fill="currentColor"><rect width="10" height="2" fill="currentColor" fillRule="evenodd"/></svg>;
};

export default React.memo(IconMinus);
